export const formatDate = (value: string): string =>
  (!!value &&
    `${value.split('T')[0].split('-')[2]}/${value.split('T')[0].split('-')[1]}/${
      value.split('T')[0].split('-')[0]
    }`) ||
  '-'
